import { toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC } from "react";

const AssetSelectItemSkeleton: FC = () => {
  return (
    <div
      className={cx(
        "motion-safe:animate-pulse",
        "relative w-full p-4",
        "flex items-center gap-2 md:gap-4",
        "rounded-lg",
        toolkitCx.layout.background.card,
        toolkitCx.layout.border.default,
        toolkitCx.layout.border.weight.default
      )}
    >
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center gap-2 md:gap-4">
          {/* Avatar */}
          <div
            className={cx(
              "h-8 w-8 rounded-full lg:h-[40px] lg:w-[40px]",
              toolkitCx.layout.background.loading
            )}
          />

          {/* Asset Meta */}
          <div className="flex w-20 flex-col items-start gap-1">
            {/* Ticker */}
            <div className={cx("h-5 w-2/3 rounded-lg", toolkitCx.layout.background.loading)} />
            {/* Name */}
            <div className={cx("h-3 w-full rounded-lg", toolkitCx.layout.background.loading)} />
          </div>
        </div>

        {/* Balance */}
        <div className="flex w-24 flex-col items-end gap-1">
          <div className={cx("h-3 w-10 rounded-lg", toolkitCx.layout.background.loading)} />
          <div className={cx("h-5 w-24 rounded-lg", toolkitCx.layout.background.loading)} />
        </div>
      </div>
    </div>
  );
};

export default AssetSelectItemSkeleton;
